// Modal to display detailed information about a specific entry in the database, 
// allow users to use this structure in the structure editor, download the SVG image, and copy the DOI to the clipboard.

import React, { useEffect, useState } from 'react'
import {
  ModalHeader,
  ModalDescription,
  ModalContent,
  ModalActions,
  Button,
  Image,
  Modal,
  Icon
} from 'semantic-ui-react'
import AutoSVG from "../visualizer-tool/automatic-svg/AutoSVG";
import { NavLink } from 'react-router-dom';

// helper functions
import databaseUtils from '../databaseUtils';

export default function InfoCardModal({entry, open, onClose}) {
    const [copied, setCopied] = useState(false);
    const undocumentedMsg = ""
    const checkData = (data) => data ? data : undocumentedMsg

    // timer to clear the copied message
    useEffect(() => {  
        const timer = setTimeout(() => {
            setCopied(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, [copied]);

    // copy DOI to clipboard
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
        .then(() => {
            setCopied(true);
        })
        .catch(err => {
            console.error('Failed to copy: ', err);
        });
    }

    // download SVG image by serialising and creating a blob
    const downloadSVG = () => {
        const modal = document.querySelector('.ui.modal'); // Select the modal container
        const svg = modal.querySelector('svg'); // Select SVG only within this modal
        if (!svg) {
            console.error("SVG element not found within modal");
            return;
        }
        const svgData = new XMLSerializer().serializeToString(svg);
        const blob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${entry.Serotype}.svg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    

  return (
    <Modal
        closeIcon
        onClose={onClose}
        open={open}
        size="fullscreen"
        dimmer="blurring"
    >

        <ModalHeader style={{backgroundColor:databaseUtils.colourMap(entry.Species_where_found)}}>
            Serotype: {entry.Serotype}</ModalHeader>
           
        <ModalContent scrolling>
        <ModalDescription style={{display: 'flex', flexDirection:'column', alignItems:'center'}}>

        <Image size='big'><AutoSVG casperString={entry.Antigen_structure === "" ? entry.Carbuilder_structure_format : entry.Antigen_structure}/></Image>
        <ModalActions>
            <NavLink to="/editor" state={entry.Antigen_structure}>
                <Button icon='edit' content='Use in structure editor'/>
            </NavLink>
            <Button icon='download' content='Download svg' onClick={downloadSVG}/>
        </ModalActions>
  
        <div className="ui grid">    
            <div class="row"> </div>     
            <div class="row">
                <div className="four wide column">Chemical Structure:</div>
                <div className="ten wide column"> <h3>{entry.Antigen_structure}</h3> </div>
            </div>   

            <div className="row">
                <div className="four wide column"><i class="bug icon"></i>Species: <div class="ui horizontal label" style={{backgroundColor:databaseUtils.colourMap(entry.Species_where_found)}}><em>{checkData(entry.Species_where_found)}</em></div></div>
              

                <div className="four wide column" > Antigen Type:  <div class="ui label">{entry.Antigen_type}</div> </div>

               

                <div className="four wide column" > <label> Repeat Unit Length:  </label>  <strong> {checkData(entry.Repeat_unit_size)}</strong></div>

                <div className="four wide column" > Branched?   { 
                                entry.Branched === 1 ? <Icon name='check' color='green' /> : 
                                entry.Branched === 0 ?<Icon name='close' color='red' /> 
                                : undocumentedMsg}</div>
            </div>
           
        {checkData(entry.NMR) && (
            <div className="row">
                <div className="six  wide column"><i class="signal icon"></i> </div>
                <div className="six wide column" > NMR data (H-1 and other proton chemical shifts in ppm):</div>
                <div className="nine wide column" > {checkData(entry.NMR)} {checkData(entry.NMR).length}</div>
            </div>)}

            
             {checkData(entry.References) && (           
            <div className="row">
                <div className="two wide column">
                    <a href={entry.DOI} target="_blank" rel="noopener noreferrer">
                        <Button icon='external alternate' content='References' />
                    </a>
                </div>
                <div className="thirteen wide column" > {checkData(entry.References)}</div>
                   
                 <div className="one wide column"><Button color={copied? 'teal' : ''} icon='copy' onClick={() => copyToClipboard(entry.DOI)} /> </div>
            </div> )}

        </div>
                    
<div style={{display:'flex', flexDirection:'column', alignItems:'flex-end'}}>
                        {copied && (
                            <div style={{color:'teal', marginBottom:'1vh'}}>
                                DOI copied to clipboard!
                            </div>
                        )}
                    </div>
                   
                    
            
      
    </ModalDescription>
</ModalContent>

      
</Modal>
  )
}
